/**
 * Catchup entity class
 */

/**
 * CatchupFactory
 * returns Catchup entity class
 *
 * @class CatchupFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.Catchup} class
 *
 * @ngdoc factory
 * @name mwApp.factory:CatchupFactory
 */
/* @ngInject */
export default function CatchupFactory (Type, Entity, onOffMixin) {
  /* === Catchup class === */

  /**
   * Catchup model
   *
   * @class Catchup
   * @classdesc Catchup model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.onOffMixin
   * @return {models.Catchup} Catchup entity
   */
  function Catchup () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  Catchup.prototype = Object.create(Entity.prototype)
  Catchup.prototype.constructor = Catchup

  /* === Catchup instance methods & fields === */

  Object.assign(Catchup.prototype, {

    /**
     * instance fields
     *
     * @memberof models.Catchup#
     * @type {Object}
     */
    _fields: {
      id: Number,
      name: String,
      channel: Type.Stump('Channel', ['id', 'name']),
      days: 1,
      enabled: Boolean,
      loaded: Boolean,
      mediaUrl: 'MediaUrlDTO',
      scheduleType: 'HOURLY',
      providerType: String,
      $customUrl: false
    },

    /**
     * url template
     *
     * @memberof models.Catchup#
     * @type {String}
     */
    _urlTemplate: 'api/channels/services/catchups/{{::id}}',

    /**
     * public url template
     *
     * @memberof models.Catchup#
     * @type {String}
     */
    _publicUrlTemplate: 'channels/catchups/services/{{::id}}',

    /**
     * Prepare channel
     *
     * @memberof models.Catchup#
     * @override
     */
    _prepare: function () {
      this.$customUrl = !!this.mediaUrl
    },

    /**
     * Get underlying object
     *
     * @memberof models.Catchup#
     * @return {Object} new underlying object as plain object
     * @override
     */
    _object: function () {
      if (this.mediaUrl && this.mediaUrl.drmProfiles && this.mediaUrl.drmProfiles.length && this.mediaUrl.drmProfiles[0].providerType === 'EXPRESS_PLAY') {
        this.mediaUrl.playbackTokenGeneratorId = null
      }
      if (this.mediaUrl && !this.mediaUrl.$extchecked) this.mediaUrl.playbackTokenGeneratorId = null
      this.mediaUrl = this.$customUrl ? this.mediaUrl : null

      return Entity.prototype._object.apply(this, arguments)
    }

  }, onOffMixin)

  /* === Catchup static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(Catchup, Entity)
  Catchup._name = 'Catchup'
  Catchup.init()

  // permissions
  Catchup.access = {
    view: 'viewCatchup',
    create: 'createCatchup',
    edit: 'editCatchup',
    delete: 'deleteCatchup'
  }

  // extra
  Catchup.extra = {
    channels: ['Channel'],
    playbackTokenGenerators: ['PlaybackTokenGenerator'],
    drmProfiles: ['DRMProfile']
  }

  return Catchup
}
